import { render } from "./VideoScroll.vue?vue&type=template&id=71b3631e"
import script from "./VideoScroll.vue?vue&type=script&lang=ts"
export * from "./VideoScroll.vue?vue&type=script&lang=ts"

import "./VideoScroll.vue?vue&type=style&index=0&id=71b3631e&lang=css"
script.render = render

export default script